import styled from 'styled-components';

export const Container = styled.div`
 width: 100%;
 height: 100%;
  background-color: #F5F5F5;
`;


export const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 0px;
  background-color: #F5F5F5;
  min-height: 100vh;
`;

export const MainCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  padding-bottom: 0px;
`;

export const ContentGrid = styled.div`
  display: grid;
  // grid-template-columns: 1fr 1fr;
  gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;